import { render, staticRenderFns } from "./TabBusinessTermDashboard.vue?vue&type=template&id=a5768b0a&scoped=true&lang=pug"
import script from "./TabBusinessTermDashboard.vue?vue&type=script&lang=js"
export * from "./TabBusinessTermDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5768b0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5768b0a')) {
      api.createRecord('a5768b0a', component.options)
    } else {
      api.reload('a5768b0a', component.options)
    }
    module.hot.accept("./TabBusinessTermDashboard.vue?vue&type=template&id=a5768b0a&scoped=true&lang=pug", function () {
      api.rerender('a5768b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/workbook/TabBusinessTermDashboard.vue"
export default component.exports